import { CircularProgress as CircularProgressMUI } from '@mui/material'
import './Spinner.scss'

const Spinner: React.FC = (): JSX.Element => {
	return (
		<div className='spinner'>
			<CircularProgressMUI className='spinner__progress' size={80} thickness={3} />
		</div>
	)
}

export default Spinner
